import { render, staticRenderFns } from "./ProductsVariable_comp.vue?vue&type=template&id=a412ace8&scoped=true&"
import script from "./ProductsVariable_comp.vue?vue&type=script&lang=js&"
export * from "./ProductsVariable_comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a412ace8",
  null
  
)

export default component.exports